import React, { useEffect, useState } from 'react';
import { Form, Input, Upload, Button, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData } from '../../../helpers/functions';
import { useNavigate } from 'react-router-dom';
import '../../../App.css';

const Biography = ({ handleNext, handleBack }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [fileName, setFileName] = useState('');
  const [isDocUploadLoading, setIsDocUploadLoading] = useState(false);
  const { updateExpertBiography } = useSelector(state => state.steps);
  const { expertDetails } = useSelector(state => state.expert);
  const navigate = useNavigate();

  const handleFileChange = info => {
    if (info.file.status === 'uploading') {
      return;
    }
    if (info.file.status === 'done') {
      setFileName(info.file.name);
      const formData = new FormData();
      formData.append('file', info.file.originFileObj);

      dispatch({ type: 'UPLOAD_RESUME_REQUEST', formData: formData });
    }
  };
  const onFinish = values => {
    const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
      if (key === 'upload_resume') {
        acc[key] = fileName; // Save just the file name
      } else if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    dispatch({
      type: 'UPDATE_BIOGRAPHY_REQUEST',
      formData: {
        ...filteredValues,
        id: expertDetails.id,
      },
    });
  };

  useEffect(() => {
    if (expertDetails) {
      const { bio, linkedin_profile, upload_resume } = expertDetails;

      form.setFieldsValue({
        bio,
        linkedin_profile,
      });

      if (upload_resume) {
        setFileName(upload_resume);
        const fileList = [
          {
            uid: '-1',
            name: upload_resume,
            status: 'done',
            url: upload_resume, // Or a proper file URL if you have it
          },
        ];
        form.setFieldsValue({ upload_resume: fileList });
      }
    }
  }, [expertDetails, form]);

  useEffect(() => {
    if (updateExpertBiography?.success) {
      if (getUserData().role?.[0]?.name === 'expert') {
        navigate('/dashboard/expert/request');
      } else {
        navigate(`/admin/experts`);
      }

      dispatch({ type: 'CLEAR_STEPS' });
    }
  }, [updateExpertBiography]);

  return (
    <div>
      <div className="site-card-border-less-wrapper card-wrapper">
        <Card bordered={false}>
          <p className="m-title tl mb-7 d-flex-center">
            <span className="back-icon" onClick={() => handleBack('biography')}>
              <IoMdArrowRoundBack />
            </span>
            <span>Provide more details</span>
          </p>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ upload_resume: [] }}
          >
            <Form.Item
              label="LinkedIn Profile"
              name="linkedin_profile"
              rules={[{ required: false, message: 'Please enter your LinkedIn profile URL' }]}
            >
              <Input placeholder="https://linkedin.com/in/yourprofile" />
            </Form.Item>

            <Form.Item
              label="Upload Resume"
              name="upload_resume"
              valuePropName="fileList"
              getValueFromEvent={e => (Array.isArray(e) ? e : e && e.fileList)}
              rules={[{ required: false, message: 'Please upload your resume' }]}
            >
              <Upload
                name="resume"
                className="resume-uploader"
                onChange={handleFileChange}
                showUploadList={true}
                maxCount={1}
                accept=".pdf,.doc,.docx"
                listType="picture"
                onRemove={() => setFileName('')}
                customRequest={({ file, onSuccess }) => {
                  setIsDocUploadLoading(true);
                  setTimeout(() => {
                    setIsDocUploadLoading(false);
                    onSuccess('ok');
                  }, 1000);
                }}
              >
                <Button
                  icon={<UploadOutlined />}
                  loading={isDocUploadLoading}
                  disabled={isDocUploadLoading}
                >
                  Choose File
                </Button>
              </Upload>
            </Form.Item>

            <Form.Item 
              label="Bio"
              name="bio"
              rules={[{ required: true, message: 'Please enter your bio' }]}
            >
              <Input.TextArea rows={3} style={{ height: '100px' }} placeholder="Tell us about yourself"   />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Biography;
